import React, {FC} from 'react';

import {InboxModel} from '../../../../../libs/shared/core/src/models/api/inboxModel';
import {isTeammateNamespace} from '../../../../../libs/shared/core/src/models/helpers/namespaceHelpers';
import {DropdownProps} from '../../../../../libs/shared/ui/src/components/dropdowns/dropdown';
import {useAppSelector} from '../../../../helpers/appReduxHelpers';
import {getIsInSandbox} from '../../../../store/data/teams/teamsSelectors';
import {SearchInboxDropdownContainer} from './searchInboxDropdownContainer';

/*
 * Props.
 */

interface SearchInboxMoveDropdown extends DropdownProps {
  selectedInbox: InboxModel;
  onChange: (model: InboxModel) => void;
}

/*
 * Component.
 */

export const SearchInboxMoveDropdown: FC<SearchInboxMoveDropdown> = (props) => {
  const {selectedInbox, onChange, ...dropdownProps} = props;

  const isInSandbox = useAppSelector(getIsInSandbox);
  const isTeammate = isTeammateNamespace(selectedInbox.namespace);

  const filterInbox = (inbox: InboxModel) => {
    if (isTeammate) {
      return true;
    }

    // Never move to sandbox.
    if (isInSandbox(inbox)) {
      return false;
    }

    return true;
  };

  return (
    <SearchInboxDropdownContainer
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...dropdownProps}
      selectedInboxIds={selectedInbox ? [selectedInbox.id] : []}
      onChange={onChange}
      namespace={isTeammate ? selectedInbox.namespace : undefined}
      shouldShowInboxPredicate={filterInbox}
    />
  );
};
